<template>
    <auth-layout>
        <div class="auth-form-container">
            <jet-validation-errors class="mb-4" />

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>            

            <h3>Accedi</h3>
            <p>Inserisci le credenziali per accedere.</p>

            <form @submit.prevent="submit" class="mt-5">
                <div class="auth-form-group">
                    <jet-input id="email" type="email" class="mt-1 auth-form-control block w-full" placeholder="Email" v-model="form.email" required autofocus />
                </div>

                <div class="auth-form-group">
                    <jet-input id="password" type="password" class="mt-1 auth-form-control block w-full" placeholder="Password" v-model="form.password" required autocomplete="current-password" />
                </div>

                <div class="auth-form-group">
                    <button type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="btn btn-primary btn-block">Accedi</button>
                </div>
                <div class="text-center mt-4">
                    <inertia-link v-if="canResetPassword" :href="route('password.request')" class="text-primary text-sm text-gray-600 hover:text-gray-900">
                        Hai dimenticato la password?
                    </inertia-link>
                </div>
            </form>
        </div>
    </auth-layout>
</template>

<script>
    import AuthLayout from '@/Layouts/AuthLayout'
    import JetButton from '@/Jetstream/Button'
    import JetInput from '@/Jetstream/Input'
    import JetCheckbox from '@/Jetstream/Checkbox'
    import JetLabel from '@/Jetstream/Label'
    import JetValidationErrors from '@/Jetstream/ValidationErrors'

    export default {
        components: {
            AuthLayout,
            JetButton,
            JetInput,
            JetCheckbox,
            JetLabel,
            JetValidationErrors
        },

        props: {
            canResetPassword: Boolean,
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false
                })
            }
        },

        methods: {
            submit() {
                this.form
                    .transform(data => ({
                        ... data,
                        remember: this.form.remember ? 'on' : ''
                    }))
                    .post(this.route('login'), {
                        onFinish: () => this.form.reset('password'),
                    })
            }
        }
    }
</script>
